import { createSlice } from '@reduxjs/toolkit';

import type { Loadable } from '../../models/loadable.model';
import { emptyLoadable } from '../../models/loadable.model';
import type { FeatureFlagsMap } from '../models/feature-flags.model';
import { loadFeatureFlags } from './feature-flags.thunk';

export interface IFeatureFlagsState {
  flags: Loadable<FeatureFlagsMap>;
}

const initialState: IFeatureFlagsState = {
  flags: emptyLoadable<FeatureFlagsMap>(),
};

const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadFeatureFlags.pending, (state) => {
        state.flags.loading = true;
        state.flags.error = undefined;
      })
      .addCase(loadFeatureFlags.fulfilled, (state, action) => {
        state.flags.loading = false;
        state.flags.loaded = true;
        state.flags.value = action.payload;
      })
      .addCase(loadFeatureFlags.rejected, (state, action) => {
        state.flags.loading = false;
        state.flags.error = action.payload;
      });
  },
});

export const featureFlagsReducer = featureFlagsSlice.reducer;
